import axios from "axios";

export interface Supplier {
  id?: string;
  companyId: string;
  name: string;
  phone: string;
  adresse: string;
  email: string;
  isDeleted?: boolean;
}

export function getSuppliersByCompanyId(companyId: string) {
  return axios
    .get<Supplier[]>(`Suppliers/getsuppliersbycompanyid`, {
      params: { companyId },
    })
    .then((res) => res.data);
}

export function addSupplier(supplier: Supplier) {
  return axios.post(`Suppliers/addsupplier`, supplier).then((res) => res.data);
}

export function updateSupplier(supplier: Supplier) {
  return axios
    .put(`Suppliers/updatesupplier`, supplier)
    .then((res) => res.data);
}

export function deleteSupplier(id: string) {
  return axios
    .delete(`/Suppliers/deletesupplier`, { data: { id } })
    .then((response) => response.data);
}
